// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1638":"3a536c72","1645":"df5ebd23","3106":"b222addf","4796":"3a536c72","5400":"bcb4a3c0","6234":"93e78ff0"}[chunkId] + ".chunk.css";
};